<script>
import lazyLoadComponent from '@router/lazyload-component'

export default {
  components: {
    FileUpload: () => lazyLoadComponent(import('@views/chat/components/FileUpload')),
  },
  data() {
    return {
      image: [],
    }
  },
  methods: {
    validateForm() {
      //  元件問題，此元件不需驗證必填
      return true
    },
    getStepData() {
      return this.image[0]?.path || ''
    },
  },
}
</script>

<template>
  <el-form ref="form" label-position="top">
    <p>住宿房型圖片</p>
    <el-form-item prop="image">
      <div class="uploaderContainer">
        <FileUpload v-model="image" class="uploaderContainer_uploader" :single="true" is-delete-save :show-upload="true" resource="hotel" :size-limit="1"></FileUpload>
        <div class="description">
          <p>圖檔最大 2 MB，檔案格式限 JPG 或 PNG。</p>
          <p>圖片比例：16 : 9，建議尺寸：1920*600px</p>
        </div>
      </div>
    </el-form-item>
  </el-form>
</template>

<style lang="scss" scoped>
.uploaderContainer {
  display: flex;

  &_uploader {
    border: none !important;

    > ::v-deep div {
      width: 382px;
      height: 216px;
      margin-bottom: 0;
    }
  }

  &_uploader + div {
    align-self: flex-end;
    margin-left: 20px;
    padding-bottom: 20px;

    p {
      color: #909399;
      font-size: 12px;
      line-height: 1.5;
      margin: 0;
      letter-spacing: 1px;
    }
  }
}
</style>
